import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export enum STATUS {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  IFORMATION = 400,
  INTERNAL_SERVER_ERROR = 500
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly toast = inject(ToastrService);
  private readonly errorPages = [STATUS.FORBIDDEN, STATUS.NOT_FOUND, STATUS.IFORMATION, STATUS.INTERNAL_SERVER_ERROR];

  private getMessage = (error: HttpErrorResponse) => {
    if (error.error?.message) {
      return error.error.message;
    }

    if (error.error?.msg) {
      return error.error.msg;
    }

    return `${error.status} ${error.statusText}`;
  };

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    if (this.errorPages.includes(error.status)) {
      const msg = error?.error?.msg;
      const sqlMessage = error?.error?.err?.sqlMessage;
      const err = error?.error?.err;
      const fallback = error?.error;

      if (msg) {
        if (error.status === 400) {
          this.toast.info(msg);
        } else {
          this.toast.error(msg);
        }
      } else if (sqlMessage) {
        this.toast.error(sqlMessage);
      } else if (err) {
        this.toast.error(err);
      } else {
        this.toast.error(fallback);
      }
      // this.router.navigateByUrl(`/${error.status}`, {
      //   skipLocationChange: true
      // });
    } else {
      if (error.status === STATUS.UNAUTHORIZED) {
        this.router.navigateByUrl('/login');
      }
    }

    return throwError(() => error);
  }
}
